import './Card.scss';

type Props = {
  children: any;
  className?: string;
};

function Card(props: Props) {
  const { children, className } = props;
  return (
    <div className={`configurator__card card p-3 ${className}`}>
      {children}
    </div>
  );
}

Card.defaultProps = { className: '' };

export default Card;
